import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { CornerMarkTranslationFragment } from "@saleor/fragments/types/CornerMarkTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsCornerMarkPageProps
  extends TranslationsEntitiesPageProps {
  cornerMark: CornerMarkTranslationFragment;
}

export const fieldNames = {
  title: "title"
};

const TranslationsCornerMarkPage: React.FC<TranslationsCornerMarkPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  cornerMark,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Corner Mark "{cornerMarkName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            cornerMarkName: maybe(() => cornerMark.titleText, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Corner Mark Title"
            }),
            name: fieldNames.title,
            translation: maybe(() =>
              cornerMark.translation ? cornerMark.translation.title : null
            ),
            type: "short" as "short",
            value: maybe(() => cornerMark.titleText)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsCornerMarkPage.displayName = "TranslationsCornerMarkPage";
export default TranslationsCornerMarkPage;
